import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "@reduxjs/toolkit";
import { fetchInitialSearchGroups } from "~/modules/search/store";

// // // //

/**
 * SearchInitializer
 * Fetches initial search groups via api (via Redux) + passes thru props.children
 */
export function SearchInitializer(props: { children: React.ReactNode }) {
    const dispatch: ThunkDispatch<{}, {}, AnyAction> = useDispatch();

    useEffect(() => {
        dispatch(fetchInitialSearchGroups());
    }, [dispatch]);

    // Pass-thru props.children
    return <React.Fragment>{props.children}</React.Fragment>;
}
